import styled from 'styled-components';
import {
  Modal as SemanticModal,
  TextArea as SemanticTextArea,
  Dropdown as SemanticDropdown,
  Button as SemanticButton,
  Checkbox as SemanticCheckBox,
} from 'semantic-ui-react';
import { Button, Header, Loader as LoaderLayoutComponent } from '@playbookux/playbook-web-core';

export const SmallText = styled.p`
  font-size: 15px;
  font-weight: 500;
`;
export const Modal = styled(SemanticModal)`
  padding: 20px 40px;
`;

export const Selector = styled(SemanticButton)`
  margin-right: 200px;
`;

export const Checkbox = styled(SemanticCheckBox)`
  margin-right: 15px;
`;

export const MergeModal = styled(SemanticModal)`
  && {
    padding: 20px 40px;
    width: 600px;
  }
`;

export const Text = styled(Header)``;

export const ButtonSave = styled(Button)`
  width: 100px;
`;

export const ButtonCancel = styled(Button.Inverted)`
  width: 100px;
`;

export const ContainerButton = styled.div`
  display: flex;
  justify-content: space-between
  margin-top: 20px;
`;

export const MergeTagContainer = styled.div`
  margin-bottom: 11px;
`;

export const BorderContainer = styled.div`
  border: 1px solid #D8D8D8;
  border-radius: 1px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 10px 15px;
  overflow: auto;
  height: 230px;
`;

export const ContainerDropdown = styled.div`
  display: flex;
  margin-top: 20px;
  flex-direction: column;
`;

export const TextArea = styled(SemanticTextArea)`
  &&& {
    height: 75px;
    resize: none;
  } 
`;

export const Dropdown = styled(SemanticDropdown)`
  width: 200px;
`;

export const InLineContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;

export const ErrorContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const Loader = styled(LoaderLayoutComponent)`
`;
